<template>
  <div class="calculator">
    <div class="results">
      <input class="input" v-model="current" />
    </div>
    <div class="mode">
      <button class="button" @click="press">sin</button>
      <button class="button" @click="press">cos</button>
      <button class="button" @click="press">tan</button>
      <button class="button" @click="press">x^</button>
      <button class="button" @click="press">del</button>
      <button class="button" @click="press">C</button>
      <button class="button" @click="press">log</button>
      <button class="button" @click="press">ln</button>
      <button class="button" @click="press">e</button>
      <button class="button" @click="press">∘</button>
      <button class="button" @click="press">rad</button>
      <button class="button" @click="press">√</button>
      <button class="button" @click="press">7</button>
      <button class="button" @click="press">8</button>
      <button class="button" @click="press">9</button>
      <button class="button" @click="press">/</button>
      <button class="button" @click="press">x²</button>
      <button class="button" @click="press">x!</button>
      <button class="button" @click="press">4</button>
      <button class="button" @click="press">5</button>
      <button class="button" @click="press">6</button>
      <button class="button" @click="press">*</button>
      <button class="button" @click="press">(</button>
      <button class="button" @click="press">)</button>
      <button class="button" @click="press">1</button>
      <button class="button" @click="press">2</button>
      <button class="button" @click="press">3</button>
      <button class="button" @click="press">-</button>
      <button class="button" @click="press">%</button>
      <button class="button" @click="press">±</button>
      <button class="button" @click="press">0</button>
      <button class="button" @click="press">.</button>
      <button class="button" @click="press">&#x003C0;</button>
      <button class="button" @click="press">+</button>
      <button class="button equal-sign" @click="press">=</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "",
      changeMode: true,
    };
  },
  methods: {
    press: function press(event) {
      var me = this;
      var key = event.target.textContent;
      if (me.current == "Infinity") {
        me.current = "";
        me.$message({
          message: "无法计算",
          type: "warning",
        });
        return;
      }
      if (me.current.indexOf("e") > -1) {
        if (key === "C") {
          me.current = "";
          return;
        }
        if (key === "del") {
          me.current = me.current.substring(0, me.current.length - 1);
          return;
        }
        me.$message({
          message: "无法计算",
          type: "warning",
        });
        return;
      }
      if (
        key != "=" &&
        key != "C" &&
        key != "*" &&
        key != "/" &&
        key != "√" &&
        key != "x²" &&
        key != "%" &&
        key != "del" &&
        key != "±" &&
        key != "sin" &&
        key != "cos" &&
        key != "tan" &&
        key != "log" &&
        key != "ln" &&
        key != "x^" &&
        key != "x!" &&
        key != "π" &&
        key != "e" &&
        key != "rad" &&
        key != "∘"
      ) {
        me.current += key;
      } else {
        if (key === "=") {
          if (me.current.indexOf("^") > -1) {
            var base = me.current.slice(0, me.current.indexOf("^"));
            var exponent = me.current.slice(me.current.indexOf("^") + 1);
            me.current = eval("Math.pow(" + base + "," + exponent + ")");
          } else {
            me.current = eval(me.current);
          }
        } else if (key === "C") {
          me.current = "";
        } else if (key === "*") {
          me.current += "*";
        } else if (key === "/") {
          me.current += "/";
        } else if (key === "+") {
          me.current += "+";
        } else if (key === "-") {
          me.current += "-";
        } else if (key === "±") {
          if (me.current.charAt(0) === "-") {
            me.current = me.current.slice(1);
          } else {
            me.current = "-" + me.current;
          }
        } else if (key === "del") {
          me.current = me.current.substring(0, me.current.length - 1);
        } else if (key === "%") {
          me.current = me.current / 100;
        } else if (key === "π") {
          me.current = me.current * Math.PI;
        } else if (key === "x²") {
          me.current = eval(me.current * me.current);
        } else if (key === "√") {
          me.current = Math.sqrt(me.current);
        } else if (key === "sin") {
          me.current = Math.sin(me.current);
        } else if (key === "cos") {
          me.current = Math.cos(me.current);
        } else if (key === "tan") {
          me.current = Math.tan(me.current);
        } else if (key === "log") {
          me.current = Math.log10(me.current);
        } else if (key === "ln") {
          me.current = Math.log(me.current);
        } else if (key === "x^") {
          me.current += "^";
        } else if (key === "x!") {
          var number = 1;
          if (me.current === 0) {
            me.current = "1";
          } else if (me.current < 0) {
            me.current = NaN;
          } else {
            var _number = 1;
            for (var i = me.current; i > 0; i--) {
              _number *= i;
            }
            me.current = _number;
          }
        } else if (key === "e") {
          me.current = Math.exp(me.current);
        } else if (key === "rad") {
          me.current = me.current * (Math.PI / 180);
        } else if (key === "∘") {
          me.current = me.current * (180 / Math.PI);
        }
        if (key != "x^") {
          if (isNaN(me.current)) {
            me.current = "";
            me.$message({
              message: "无法计算",
              type: "warning",
            });
          }
        }
        me.current += "";
      }
    },
  },
};
</script>

<style scoped>
.calculator {
  width: 440px;
  padding: 20px;
  border-radius: 5px;
  font-size: 16px;
  background-color: #333333;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99999;
}

.input {
  width: 420px;
  height: 50px;
  border-radius: 0px;
  border: 1px solid black;
  background-color: #333333;
  color: #d9d9d9;
  padding: 0 5px 0 5px;
  margin: 0 0px 10px 0px;
  font-size: 30px;
}

.input:focus,
.input:active {
  border-color: #03a9f4;
  box-shadow: 0 0 4px #03a9f4;
  outline: none 0;
}

.button {
  margin: 3px;
  width: 63px;
  border: 1px solid #0d0d0d;
  height: 30px;
  border-radius: 4px;
  color: #d9d9d9;
  background-color: #1a1a1a;
  cursor: pointer;
  outline: none;
}

.mode {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.equal-sign {
  background-color: green;
  width: 133px;
}

.toggle-button {
  border: none;
  background-color: #333333;
  cursor: pointer;
  outline: none;
  font-size: 1rem;
  color: #fff;
  text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.35);
}

p {
  margin-top: 0;
}

button::-moz-focus-inner {
  border-color: transparent;
}
button,
hr,
input {
  overflow: visible;
}
audio,
canvas,
progress,
video {
  display: inline-block;
}
progress,
sub,
sup {
  vertical-align: baseline;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
menu,
article,
aside,
details,
footer,
header,
nav,
section {
  display: block;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
figcaption,
figure,
main {
  display: block;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
a {
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:active,
a:hover {
  outline-width: 0;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}
b,
strong {
  font-weight: bolder;
}
dfn {
  font-style: italic;
}
mark {
  background-color: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
img {
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}
button,
input {
}
button,
select {
  text-transform: none;
}
[type="submit"],
[type="reset"],
button,
html [type="button"] {
  -webkit-appearance: button;
}
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring,
button:-moz-focusring {
  outline: ButtonText dotted 1px;
}
fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
progress {
}
textarea {
  overflow: auto;
}
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
summary {
  display: list-item;
}
[hidden],
template {
  display: none;
} /*# sourceMappingURL=normalize.min.css.map */
</style>


// WEBPACK FOOTER //
// src/components/calculator.vue